import NavbarFooter from './NavbarFooter';

export default NavbarFooter;
